import { take, slice, sortBy } from 'lodash';
import { getBalanceOverrideColor } from 'application/util/balance-highlight.util';

import './calendar-day.style.sass';
import template from './calendar-day.tpl.pug';

class CalendarDayController {
    /* @ngInject */
    constructor(eventUtil) {
        this.eventUtil = eventUtil;
    }

    $onChanges(changeObject) {
        if (changeObject.limit) {
            this.limit = changeObject.limit.currentValue;
        }

        let limit = this.limit == null ? 4 : Math.max(this.limit, 0);

        if (changeObject.events) {
            this.events = this.sort(changeObject.events.currentValue || []);
        }

        if (changeObject.events || changeObject.limit) {
            this.more = this.events.length > limit
                ? this.events.length - limit + 1
                : 0;

            this.displayedEvents = this.more > 1
                ? take(this.events, this.events.length - this.more)
                : this.events.slice();
        }
    }

    sort(events) {
        events = events || [];
        
        return sortBy(slice(events), (event) => event.confirmed, (event) => event.timestamp);
    }

    clickHeading() {
        return this.onListClick();
    }

    clickMore() {
        return this.onListClick();
    }

    clickAddEvent() {
        return this.onAddClick();
    }

    selectEvent(event) {
        return this.onEventClick({
            event
        });
    }

    eventDrop(event) {
        return this.onEventDrop({
            event
        });
    }

    validateEventDrop(event) {
        return this.events && this.events.indexOf(event) < 0;
    }

    getBalanceOverrideColor(value) {
        if (this.loadingBalances) {
            return null;
        }

        return getBalanceOverrideColor(value, this.balanceWarningThreshold);
    }
}

export default {
    selector: 'dbACalendarDay',
    template: template(),
    controller: CalendarDayController,
    bindings: {
        date: '<',
        change: '<',
        balance: '<',
        events: '<',
        today: '<',
        another: '<',
        loadingBalances: '<',
        balanceWarningThreshold: '<',
        limit: '<',
        useCategoryIcons: '<',
        
        canManageEvents: '<',

        onListClick: '&',
        onAddClick: '&',
        onEventClick: '&',
        onEventDrop: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-day/calendar-day.cmpt.js